export default __webpack_public_path__ + "static/media/apple-touch-icon-57x57.d8acec5b.png";